import { render, staticRenderFns } from "./ScreenSlider.vue?vue&type=template&id=ac736566&"
import script from "./ScreenSlider.vue?vue&type=script&lang=js&"
export * from "./ScreenSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports